import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ExcRestService} from 'exc-rest';
import {ExcTranslation} from 'exc-core';
import {ExcListConfig} from 'exc-controls';
import {ExcTab, IExcTab} from 'exc-tab';
import {ExcCoreModule} from 'exc-core';

import {DefaultSettingsService} from '../default-settings-service.service';
import {AuditDetailsComponent} from '../audit-details/audit-details.component';
import {ModalAssignReviewsComponent} from "../modals/modal-assign-reviews/modal-assign-reviews.component";
import {ActivatedRoute} from "@angular/router";
import {ExcFilter, ExcFilterCondition, ExcSort, FilterSortService} from '../filter-sort-service.service';
import {AuditReviewComponent} from '../audit-review/audit-review.component';
import {Observable} from 'rxjs';
import {AuditActionResult} from '../audit-action-service.service';
import {ExcSigninService} from 'exc-signin';
import {ReviewActionService} from '../review-action-service';
import {ModalYesNoComponent} from '../modals/modal-yes-no/modal-yes-no.component';

@Component({
  selector: 'app-review-list-done',
  templateUrl: './review-list-done.component.html',
  styles: []
})
export class ReviewListDoneComponent extends ExcTranslation implements  OnInit, OnDestroy {
  @ViewChild('filterMenu') filterMenu;
  listconfig: ExcListConfig = new ExcListConfig();
  searchValue: string = null;
  data: any[] = [];
  selectedItems = [];
  reviewEditors = [];
  mode = '';
  lstFilters: ExcFilter[] = [];
  lstSort: ExcSort[] = [];

  constructor(private excRest: ExcRestService, private excDss: DefaultSettingsService, private route: ActivatedRoute,
              private excFss: FilterSortService, private excSec: ExcSigninService, private excRas: ReviewActionService) {
    super();
    const _self = this;

    _self.listconfig.selectionMode = _self.excSec.isFeatured('CLI_REVDSP_CU') ? 'multi' : 'none';
    _self.listconfig.paging = {pagingTotalRows: 0, pagingTotalPages: 0, pagingPage: 0, pagingPageSize: 10};
    _self.listconfig.OnSearch = function (searchValue) {
      _self.searchValue = searchValue || '';
      _self.initialLoad();
    };
    _self.listconfig.OnPageChanged = (pageNo) => {
      _self.listconfig.paging.pagingPage = pageNo;
      _self.initialLoad();
    };
    _self.listconfig.OnRefresh = () => {
      _self.initialLoad();
    };
    // _self.listconfig.OnDetailLink = (item) => {
    //   new ExcTab(item.DealerName, AuditDetailsComponent, item, item.DealerID, {
    //     Unique: true, ReloadParent: function () {
    //     }
    //   }, true).Open();
    // };
    _self.listconfig.OnFilterClick = (event) => {
      _self.filterMenu.show(event);
    };
    _self.listconfig.OnFilter = () => { };
    _self.listconfig.OnSelectionChanged = (selectedItems: any) => {
      _self.selectedItems = [...selectedItems];
    };
  }
  openAudit(item) {
    const _self = this;
    new ExcTab(item.DealerName + ' - ' + item.AuditID, AuditDetailsComponent, item, item.AuditID, {
      Unique: true, ReloadParent: function () {
        _self.initialLoad();
      }
    }, true).Open();
  }
  openReview(item) {
    const _self = this;
    new ExcTab(item.DealerName + ' - ' + item.AuditID, AuditReviewComponent, item, item.AuditID, {
      Unique: true, ReloadParent: function () {
        _self.initialLoad();
      }
    }, true).Open();
  }
  reOpenReview(item) {
    const _self = this;

    ExcCoreModule.showModal(ModalYesNoComponent, null, 'xs', {Message: _self.getGlobal('ReOpenReviewWarning')}, false).subscribe( r => {
      if (r && r.proceed === true) {
        const url = _self.excRest.computeUrl('ReviewU_Reopen', {AuditID: item.AuditID});
        _self.excRest.post(url, {}, {}).subscribe(response => {
          new ExcTab(item.DealerName + ' - ' + item.AuditID, AuditReviewComponent, item, item.AuditID, {
            Unique: true, ReloadParent: function () {
              _self.initialLoad();
            }
          }, true).Open();
        });
      }
    });





  }
  ngOnInit() {
    const _self = this;
    _self.lstFilters =  [
      new ExcFilter(1, 'Status', 'ReviewInProgress', new ExcFilterCondition('=', false), 'fltOpen', 'Globals.onlyOpen', false)
      , new ExcFilter(1, 'Audit', 'AuditIsGroup', new ExcFilterCondition('=', 1), 'fltPicked', 'Globals.GroupAudit', false)
      , new ExcFilter(1, 'Audit', 'Auftr_Ispicked', new ExcFilterCondition('=', true), 'fltGroup', 'Globals.PickedCheck', false)
      , new ExcFilter(1, 'Audit', 'AuditLevel', new ExcFilterCondition('=', 2), 'fltLevel2', _self.getGlobal('AuditOnLevel', {lvl: (_self.excDss.MandantSettings['Labels']['DealerLevel2'] || _self.getGlobal('DealerLevel2'))}), false)
      , new ExcFilter(1, 'Audit', 'AuditLevel', new ExcFilterCondition('=', 3), 'fltLevel3', _self.getGlobal('AuditOnLevel', {lvl: (_self.excDss.MandantSettings['Labels']['DealerLevel3'] || _self.getGlobal('DealerLevel3'))}), false)
      , new ExcFilter(2, '', 'DealerName', new ExcFilterCondition('like', ''), 'fltSearchDealerName', 'Globals.DealerName', false)
      , new ExcFilter(2, '', 'DealerLevel1', new ExcFilterCondition('like', ''), 'fltSearchDealerLevel1', (this.excDss.MandantSettings['Labels']['DealerLevel1'] || 'Globals.DealerLevel1'), false)
      , new ExcFilter(2, '', 'DealerLevel2', new ExcFilterCondition('like', ''), 'fltSearchDealerLevel2', (this.excDss.MandantSettings['Labels']['DealerLevel2'] || 'Globals.DealerLevel2'), false)
    ];
    _self.lstSort = [
      new ExcSort('AuditEnd', 0, 'Globals.InboxDate', 2)
      , new ExcSort('AuditTotalStock', 0, 'Globals.AmountTotalStock', 0)
      , new ExcSort('AuditFindings', 0, 'Globals.AmountFindings', 0)
      , new ExcSort('AuditFindingsCrit', 0, 'Globals.AmountFindingsCrit', 0)
    ];
    for (const x of _self.lstFilters) {
      x.Container = _self.lstFilters;
    }
    for (const x of _self.lstSort) {
      x.Container = _self.lstSort;
    }
    this.initialLoad();
  }
  applyFilter() {
    this.filterMenu.hide();
    this.listconfig.MetaInfo.dataFilter = {some: 'value'};
    this.initialLoad();
  }
  resetFilter() {
    this.excFss.ResetFilter(this.lstFilters, this.lstSort);
    this.filterMenu.hide();
    this.listconfig.MetaInfo.dataFilter = {};
    this.initialLoad();
  }
  ngOnDestroy(): void {
    // this.routeSub && this.routeSub.unsubscribe();
  }
  initialLoad () {
    const _self = this;
    const url = _self.excRest.computeUrl('ReviewDoneR_List', {fts: this.searchValue == null ? '' : this.searchValue});
    let mi = this.listconfig.GetMetaInfo();
    mi =  this.excFss.ApplyFilter(mi, this.lstFilters, this.lstSort);
    _self.listconfig.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret !== null) {
        _self.data = ret.data;
        _self.listconfig.paging = ret.paging;
        // _self.listconfig.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
      } else {
        _self.data = [];
      }
      _self.listconfig.isLoading = false;

    });
  }
  getAvatarClass(data) {
    return data.AuditType === 16
      ? data.AuditIsPicked ? 'fa-mobile th-warning' : 'fa-mobile th-secondary'
      : data.AuditIsPicked ? 'fa-user-secret th-warning' : 'fa-user-secret th-secondary';
  }
}
